<div>
    <mat-form-field>
        <mat-label>{{ $name() }}</mat-label>
        <mat-select
            name="booleanLabel"
            [ngModel]="$value()"
            (ngModelChange)="onChanged.emit($event)"
            [ngModelOptions]="{standalone: true}"
            [disabled]="$disabled()"
        >
            @for (option of $optionsArray(); track option.state) {
                <mat-option [value]="option.state">{{ option.label }}</mat-option>
            }
        </mat-select>
    </mat-form-field>
</div>
